import { render, staticRenderFns } from "./PDPAnalysis.vue?vue&type=template&id=5637f3eb&scoped=true"
import script from "./PDPAnalysis.vue?vue&type=script&lang=js"
export * from "./PDPAnalysis.vue?vue&type=script&lang=js"
import style0 from "./PDPAnalysis.vue?vue&type=style&index=0&id=5637f3eb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5637f3eb",
  null
  
)

export default component.exports